import { type ButtonHTMLAttributes } from 'react';
import { Button, ButtonInner, Svg } from './ArrowButton.styles';

interface ArrowButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  direction: 'left' | 'right';
}

const ArrowButton = ({ direction, ...rest }: ArrowButtonProps) => {
  return (
    <Button direction={direction} {...rest}>
      <ButtonInner>
        <Svg
          direction={direction}
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="13"
          viewBox="0 0 20 13"
          fill="none"
        >
          <path
            d="M6 1.14258L1 6.14258L6 11.1426"
            stroke="#290042"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M2 6.14258H20" stroke="#290042" strokeWidth="2" />
        </Svg>
      </ButtonInner>
    </Button>
  );
};

export default ArrowButton;
